<template>
	<div class="ai_share_card_1">
		
		<div v-if="content1" class="audioTtsLoadingCard aiCard" v-loading="playState === 'loading'" element-loading-text="正在生成语音朗读" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0,0,0,0)">
			<div class="cardHeader">
				<div class="cardTitle">{{ this.$props.data.text == '帮我解读“当日需及时关心的长者”' ? '好的，以下是今日“需及时关心”的长者清单：' : (this.$props.data.text ? this.$props.data.text : (this.$props.data.title ? this.$props.data.title : '')) }} </div>
			</div>
			<div class="cardDivider"></div>
			<div class="markdownContent cardContent">
				<div class="markdownContent" v-html="content1"></div>
			</div>
			<div v-if="enableAudio" class="tool_container toolContainer toolContainerNormal">
				<div class="play_btn" :class="{ 'is-pressed': playBtnPressed }" @click="onPlayBtnClick" @touchstart.passive="onPlayBtnPressStart" @touchend="onPlayBtnPressEnd" @touchcancel="onPlayBtnPressEnd" @mousedown="onPlayBtnPressStart" @mouseup="onPlayBtnPressEnd" @mouseleave="onPlayBtnPressEnd">
					<img :src="playIconSrc" class="playIconSmall" alt="语音播放" draggable="false" />
				</div>
			</div>
		</div>
		<div v-if="!content1" class="audioTtsLoadingCard aiCard" v-loading="playState === 'loading'" element-loading-text="正在生成语音朗读" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0,0,0,0)">
			<div class="cardHeader">
				<div class="cardTitle">{{ this.$props.data.text == '帮我解读“当日需及时关心的长者”' ? '好的，以下是今日“需及时关心”的长者清单：' : (this.$props.data.text ? this.$props.data.text : (this.$props.data.title ? this.$props.data.title : '')) }} </div>
			</div>
			<div class="cardDivider"></div>
			
			<div class="markdownContent thoughtBox">
				<div class="thoughtHeader" @click="clickUnflod()">
					<div class="thoughtHeaderLeft">
						<img class="thoughtIcon" src="../../assets/icon_ai_depth_icon_1.png" alt="" />
						<div class="thoughtTitle">{{ '已深度思考' }}</div>
					</div>
					<img v-if="!isUnfold" class="thoughtArrow" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false" />
					<img v-if="isUnfold" class="thoughtArrow" src="../../assets/icon_home_ai_icon_3_2.png" alt="" draggable="false" />
				</div>
				<div v-if="isUnfold" class="markdownContent ai_thought_content" v-html="content2"></div>
			</div>
			
			<div class="markdownContent cardContent">
				<div class="markdownContent ai_content_text" v-html="content3"></div>
			</div>
			<div class="split"></div>
			<div v-if="enableAudio" class="tool_container toolContainer toolContainerBottom">
				<div class="play_btn" :class="{ 'is-pressed': playBtnPressed }" @click="onPlayBtnClick" @touchstart.passive="onPlayBtnPressStart" @touchend="onPlayBtnPressEnd" @touchcancel="onPlayBtnPressEnd" @mousedown="onPlayBtnPressStart" @mouseup="onPlayBtnPressEnd" @mouseleave="onPlayBtnPressEnd">
					<img :src="playIconSrc" class="playIcon" alt="语音播放" draggable="false" />
				</div>
			</div>
		</div>
		<div v-if="isLoading" class="loadingContent cardLoading" v-loading="isLoading" element-loading-text="AI分析中，请稍候..."></div>
	</div>
</template>
  
<script>

import {marked} from 'marked'
import axios from 'axios';
import playIcon from '../../assets/icon_ai_play.png'
import loadingIcon from '../../assets/icon_ai_play_loading.gif'
import playingIcon from '../../assets/icon_ai_play_playing.gif'

const AUDIO_CACHE = {};
// A tiny silent wav used to unlock Safari audio playback inside a user gesture
const SILENT_AUDIO_DATA_URI = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA=';
// Proxy path, devServer rewrites to Aliyun /stream/v1/tts (short-text)
const ALIYUN_TTS_ENDPOINT = '/aliyun-tts';
const DEFAULT_VOICE = 'xiaoyun';
const DEFAULT_FORMAT = 'mp3';
const DEFAULT_SAMPLE_RATE = 16000;
const SHORT_TTS_MAX_LEN = 280;
const APP_KEY_PLACEHOLDER = 'SDEyHlOVyDcGMCwf';
const TOKEN_API_PLACEHOLDER = '/api/aliyun/tts/token';
const TOKEN_CACHE_KEY = 'TTSToken';
const TOKEN_EXPIRE_KEY = 'TTSTokenExpireTime';

export default {
	props: {
		data: {
			type: Object,
			default: null
		},
		dataIndex: {
			type: Number,
			default: null
		},
		enableAudio: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		playIconSrc() {
			if (this.playState === 'loading') return loadingIcon;
			if (this.playState === 'playing') return playingIcon;
			return playIcon;
		}
	},
	watch: {
		
	},
	data() {
		return {


			rawContent: '',
			displayedContent: '',

			isLoading: false,

			
			content1: null,

			content2: null,
			content3: null,
			
			isUnfold: false

			,

			playState: 'idle', // idle | loading | playing
			audioInstance: null,
			cancelRequested: false,
			lastAudioUrl: null,
			ttsToken: null,
			segmentAudioUrls: [],
			currentSegmentIndex: 0,
			isPlaybackPaused: false,
			isSynthesisLoading: false,
			playBtnPressed: false,
			playBtnPressResetTimer: null

			,
			audioUnlocked: false

		};
	},
	created() {
	},
	mounted() {
		this.$nextTick(() => {
			let content = this.$props.data.content || '';
			marked.use({
				mangle: false,
				headerIds: false
			});
			let markdownStr = content ? content : '';
			let needStr = markdownStr || '';
			// 将小波浪号替换为大波浪号,解决删除线的问题
			let newNeedStr = needStr.replace(/~/g, "～")

			this.rawContent = this.rawContent + '\n\n' + newNeedStr || '';

			const delimiter = 'QingleiSplitThought';
			if (this.rawContent.indexOf(delimiter) >= 0) {
				let tempArr = this.rawContent.split(delimiter);
				let thoughtMarkdown = (tempArr[0] || '').trim();
				let answerMarkdown = (tempArr[1] || '').trim();
				this.content2 = marked(thoughtMarkdown);
				this.content3 = marked(answerMarkdown);
				this.content1 = null;
				this.displayedContent = `${this.content2}${this.content3}`;
			} else {
				this.displayedContent = marked(this.rawContent);
				this.content1 = this.displayedContent;
				this.content2 = null;
				this.content3 = null;
			}
		})
	},
	methods: {
		onPlayBtnClick() {
			this.triggerPlayBtnPressedVisual();
			this.ensureAudioUnlocked();
			this.handlePlayClick();
		},
		onPlayBtnPressStart() {
			if (!this.isTouchLikeDevice()) return;
			if (this.playBtnPressResetTimer) {
				clearTimeout(this.playBtnPressResetTimer);
				this.playBtnPressResetTimer = null;
			}
			this.playBtnPressed = true;
		},
		onPlayBtnPressEnd() {
			if (!this.isTouchLikeDevice()) return;
			if (this.playBtnPressResetTimer) {
				clearTimeout(this.playBtnPressResetTimer);
			}
			this.playBtnPressResetTimer = setTimeout(() => {
				this.playBtnPressed = false;
				this.playBtnPressResetTimer = null;
			}, 90);
		},
		triggerPlayBtnPressedVisual() {
			if (!this.isTouchLikeDevice()) return;
			this.playBtnPressed = true;
			if (this.playBtnPressResetTimer) {
				clearTimeout(this.playBtnPressResetTimer);
			}
			this.playBtnPressResetTimer = setTimeout(() => {
				this.playBtnPressed = false;
				this.playBtnPressResetTimer = null;
			}, 140);
		},
		isTouchLikeDevice() {
			if (typeof window === 'undefined' || !window.matchMedia) return false;
			return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
		},
		clickUnflod() {
			this.isUnfold = !this.isUnfold;
		},
		handlePlayClick() {
			if (!this.enableAudio) return;
			if (this.isSynthesisLoading) {
				this.stopPlayback(true);
				return;
			}
			if (this.playState === 'playing') {
				this.stopPlayback(false);
				return;
			}
			if (this.playState === 'loading') {
				this.stopPlayback(true);
				return;
			}
			this.startPlayback();
		},
		async startPlayback() {
			try {
				if (this.isPlaybackPaused && this.audioInstance) {
					this.isPlaybackPaused = false;
					await this.audioInstance.play();
					this.playState = 'playing';

					// Resume current segment from currentTime; do not reset src/load here.
					await this.waitForCurrentSegmentEnd();
					if (this.cancelRequested || this.isPlaybackPaused) {
						return;
					}
					this.currentSegmentIndex += 1;
					await this.playSegmentQueue();
					return;
				}

				this.cancelRequested = false;
				this.isPlaybackPaused = false;
				const speakText = this.getSpeakText();
				if (!speakText) throw new Error('暂无可朗读内容');

				const cacheKey = this.getContentCacheKey(speakText);
				let audioUrls = AUDIO_CACHE[cacheKey];
				if (!audioUrls || !audioUrls.length) {
					const token = await this.ensureToken();
					this.playState = 'loading';
					const segments = this.splitTextForShortTts(speakText, SHORT_TTS_MAX_LEN);
					this.isSynthesisLoading = true;
					audioUrls = [];
					for (let i = 0; i < segments.length; i += 1) {
						if (this.cancelRequested) {
							this.playState = 'idle';
							this.isSynthesisLoading = false;
							return;
						}
						const segmentAudioUrl = await this.requestShortTtsAudio(segments[i], token);
						audioUrls.push(segmentAudioUrl);
					}
					this.isSynthesisLoading = false;
					AUDIO_CACHE[cacheKey] = audioUrls;
				} else {
					this.playState = 'loading';
					this.isSynthesisLoading = false;
				}
				this.segmentAudioUrls = audioUrls;
				this.currentSegmentIndex = 0;
				this.lastAudioUrl = audioUrls.length ? audioUrls[0] : null;

				if (this.cancelRequested) {
					this.playState = 'idle';
					return;
				}

				await this.playSegmentQueue();
			} catch (err) {
				if (this.cancelRequested) return;
				console.error('音频播放失败', err);
				this.playState = 'idle';
			} finally {
				this.isSynthesisLoading = false;
			}
		},
		getSpeakText() {
			let content = this.$props.data && this.$props.data.content ? this.$props.data.content : '';
			const delimiter = 'QingleiSplitThought';
			if (content.indexOf(delimiter) >= 0) {
				const parts = content.split(delimiter);
				content = parts[1] || '';
			}
			content = content.replace(/~/g, '～');
			content = content.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ');
			content = content.replace(/\[(.*?)\]\((.*?)\)/g, '$1');
			content = content.replace(/[#>*`_]/g, ' ');
			content = content.replace(/<[^>]+>/g, ' ');
			content = content.replace(/\s+/g, ' ');
			return content.trim();
		},
		getContentCacheKey(text) {
			return `${this.$props.dataIndex || 0}-${text}`;
		},
		splitTextForShortTts(text, maxLen) {
			const normalized = (text || '').replace(/\s+/g, ' ').trim();
			if (!normalized) return [];
			if (normalized.length <= maxLen) return [normalized];

			const chunks = [];
			let start = 0;
			while (start < normalized.length) {
				let end = Math.min(start + maxLen, normalized.length);
				if (end < normalized.length) {
					const windowText = normalized.slice(start, end);
					const breakIndex = Math.max(
						windowText.lastIndexOf('。'),
						windowText.lastIndexOf('！'),
						windowText.lastIndexOf('？'),
						windowText.lastIndexOf('；'),
						windowText.lastIndexOf('，'),
						windowText.lastIndexOf(','),
						windowText.lastIndexOf('.')
					);
					if (breakIndex >= Math.floor(maxLen * 0.5)) {
						end = start + breakIndex + 1;
					}
				}
				chunks.push(normalized.slice(start, end).trim());
				start = end;
			}

			return chunks.filter(Boolean);
		},
		async ensureToken() {
			if (this.ttsToken) return this.ttsToken;
			try {
				const cachedToken = localStorage.getItem(TOKEN_CACHE_KEY);
				const cachedExpire = parseInt(localStorage.getItem(TOKEN_EXPIRE_KEY), 10);
				const nowSec = Math.floor(Date.now() / 1000);
				if (cachedToken && Number.isFinite(cachedExpire) && nowSec < cachedExpire) {
					this.ttsToken = cachedToken;
					return cachedToken;
				}
			} catch (e) {
				console.warn('读取本地TTS token失败', e);
			}
			let loadingInstance = null;
			try {
				loadingInstance = this.$loading({
					lock: true,
					text: '数据获取中...',
					background: 'rgba(0, 0, 0, 0.25)'
				});
				const token = await new Promise((resolve, reject) => {
					this.$get('/api/healthReportAi/nlsAccessToken', {}, (res) => {
						const tokenVal = res && res.data ? res.data.token : null;
						const expireVal = res && res.data ? res.data.expireTime : null;
						const isOk = res && (res.code === 0 || typeof res.code === 'undefined');
						if (!isOk || !tokenVal) {
							const msg = (res && res.msg) ? res.msg : '获取语音令牌失败';
							reject(new Error(msg));
							return;
						}
						try {
							const nowSec = Math.floor(Date.now() / 1000);
							let expireSec = parseInt(expireVal, 10);
							if (!Number.isFinite(expireSec) || expireSec <= nowSec) {
								expireSec = nowSec + 300; // fallback 5 minutes
							}
							localStorage.setItem(TOKEN_CACHE_KEY, tokenVal);
							localStorage.setItem(TOKEN_EXPIRE_KEY, String(expireSec));
						} catch (e) {
							console.warn('缓存TTS token失败', e);
						}
						resolve(tokenVal);
					}, (err) => {
						reject(err || new Error('获取语音令牌失败'));
					});
				});
				this.ttsToken = token;
				return token;
			} finally {
				if (loadingInstance && typeof loadingInstance.close === 'function') {
					loadingInstance.close();
				}
			}
		},
		async requestShortTtsAudio(text, token) {
			const payload = {
				appkey: APP_KEY_PLACEHOLDER,
				token,
				text,
				format: DEFAULT_FORMAT,
				sample_rate: DEFAULT_SAMPLE_RATE
			};
			const response = await fetch(ALIYUN_TTS_ENDPOINT, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(payload)
			});

			const contentType = response.headers.get('content-type') || '';
			if (!response.ok || contentType.indexOf('application/json') >= 0) {
				const errorText = await response.text();
				let message = `语音合成失败(${response.status})`;
				try {
					const errJson = JSON.parse(errorText || '{}');
					message = errJson.error_message || errJson.message || message;
				} catch (e) {
					if (errorText) message = errorText;
				}
				throw new Error(message);
			}

			const audioBuffer = await response.arrayBuffer();
			if (!audioBuffer || !audioBuffer.byteLength) {
				throw new Error('语音数据为空');
			}
			const blob = new Blob([audioBuffer], { type: 'audio/mpeg' });
			return URL.createObjectURL(blob);
		},
		async playSegmentQueue() {
			while (this.currentSegmentIndex < this.segmentAudioUrls.length) {
				if (this.cancelRequested || this.isPlaybackPaused) return;
				const url = this.segmentAudioUrls[this.currentSegmentIndex];
				await this.playAudioUrl(url);
				if (!this.isPlaybackPaused && !this.cancelRequested) {
					this.currentSegmentIndex += 1;
				}
			}
			if (!this.cancelRequested && !this.isPlaybackPaused) {
				this.playState = 'idle';
				this.currentSegmentIndex = 0;
			}
		},
		async playAudioUrl(audioUrl) {
			return new Promise((resolve, reject) => {
				const audio = this.audioInstance || new Audio();
				this.audioInstance = audio;
				this.lastAudioUrl = audioUrl;

				audio.onended = () => {
					if (!this.isPlaybackPaused && !this.cancelRequested) {
						this.playState = 'playing';
					}
					resolve();
				};
				audio.onerror = (e) => {
					this.playState = 'idle';
					reject(e);
				};
				audio.onpause = () => {
					if (this.isPlaybackPaused) {
						resolve();
						return;
					}
					if (audio.currentTime === 0 && this.playState !== 'loading') {
						this.playState = 'idle';
					}
				};

				// Reuse unlocked element to satisfy Safari gesture requirement
				try {
					audio.src = audioUrl;
					audio.load();
				} catch (e) {
					console.warn('重置音频源失败', e);
				}

				audio.play().then(() => {
					if (!this.cancelRequested) {
						this.playState = 'playing';
					}
				}).catch((err) => {
					this.playState = 'idle';
					reject(err);
				});
			});
		},
		waitForCurrentSegmentEnd() {
			return new Promise((resolve, reject) => {
				const audio = this.audioInstance;
				if (!audio) {
					resolve();
					return;
				}

				const cleanup = () => {
					audio.removeEventListener('ended', onEnded);
					audio.removeEventListener('pause', onPause);
					audio.removeEventListener('error', onError);
				};
				const onEnded = () => {
					cleanup();
					resolve();
				};
				const onPause = () => {
					if (!this.isPlaybackPaused && !this.cancelRequested) return;
					cleanup();
					resolve();
				};
				const onError = (e) => {
					cleanup();
					reject(e);
				};

				audio.addEventListener('ended', onEnded);
				audio.addEventListener('pause', onPause);
				audio.addEventListener('error', onError);
			});
		},
		stopPlayback(resetToStart) {
			if (!resetToStart && this.playState === 'playing' && this.audioInstance) {
				this.isPlaybackPaused = true;
				try {
					this.audioInstance.pause();
				} catch (e) {
					console.warn('暂停音频失败', e);
				}
				this.playState = 'idle';
				return;
			}

			this.cancelRequested = true;
			this.isPlaybackPaused = false;
			this.isSynthesisLoading = false;
			if (this.audioInstance) {
				try {
					if (resetToStart) this.audioInstance.currentTime = 0;
					this.audioInstance.pause();
				} catch (e) {
					console.warn('停止音频失败', e);
				}
			}
			this.playState = 'idle';
			this.lastAudioUrl = null;
			if (this.audioInstance) {
				try {
					this.audioInstance.src = '';
				} catch (e) {
					console.warn('重置音频源失败', e);
				}
			}
			this.segmentAudioUrls = [];
			this.currentSegmentIndex = 0;
			setTimeout(() => {
				this.cancelRequested = false;
			}, 0);
		},
		ensureAudioUnlocked() {
			try {
				if (!this.audioInstance) {
					this.audioInstance = new Audio();
					this.audioInstance.preload = 'auto';
				}
				if (this.audioUnlocked) return;
				const audio = this.audioInstance;
				audio.muted = true;
				audio.src = SILENT_AUDIO_DATA_URI;
				const playPromise = audio.play();
				if (playPromise && typeof playPromise.then === 'function') {
					playPromise.then(() => {
						audio.pause();
						audio.currentTime = 0;
						audio.muted = false;
						this.audioUnlocked = true;
					}).catch(() => {
						// Ignore; Safari might still allow subsequent play since gesture initiated
						audio.muted = false;
						this.audioUnlocked = true;
					});
				} else {
					this.audioUnlocked = true;
				}
			} catch (e) {
				console.warn('音频解锁失败', e);
			}
		}
	},
	beforeDestroy() {
		if (this.playBtnPressResetTimer) {
			clearTimeout(this.playBtnPressResetTimer);
			this.playBtnPressResetTimer = null;
		}
		this.stopPlayback(true);
		if (this.audioInstance) {
			try {
				this.audioInstance.pause();
				this.audioInstance.src = '';
			} catch (e) {
				console.warn('销毁音频失败', e);
			}
			this.audioInstance = null;
		}
	}
};
</script>
<style lang="scss" scoped>

::v-deep .audioTtsLoadingCard > .el-loading-mask {
	background: transparent !important;
	pointer-events: none;
}

::v-deep .audioTtsLoadingCard > .el-loading-mask .el-loading-spinner {
	left: 50% !important;
	top: 50% !important;
	width: 172px !important;
	margin-top: 0 !important;
	transform: translate(-50%, -50%);
	border-radius: 8px;
	background: rgba(0, 0, 0, 0.5);
	display: inline-flex;
	align-items: center;
	gap: 4px;
	box-shadow: 0 8px 22px rgba(0, 0, 0, 0.22);
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 12px;
	padding-bottom: 12px;
	backdrop-filter: blur(8px);
}

::v-deep .audioTtsLoadingCard > .el-loading-mask .el-loading-spinner .el-icon-loading {
	color: #ffffff;
	font-size: 18px;
	margin-top: 0;
}

::v-deep .audioTtsLoadingCard > .el-loading-mask .el-loading-spinner .el-loading-text {
	margin: 0 !important;
	font-family: PingFangSC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	line-height: 22px;
}

::v-deep .loadingContent {
	.el-loading-spinner {
		margin-top: -35px !important;
	}
}


.ai_share_card_1 {
	display: flex;
	flex-direction: column;
	width: 100%;

	.aiCard {
		position: relative;
		background: #FFFFFF;
		box-shadow: 0 0 10px 0 #D9E7F1;
		border-radius: 2px 12px 12px 12px;
		display: flex;
		flex-direction: column;
		margin-top: 15px;
		width: 100%;
	}

	.cardHeader {
		display: flex;
		justify-content: space-between;
		padding: 20px 20px 14px 20px;
	}

	.cardTitle {
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		font-size: 16px;
		color: #1F2635;
		line-height: 22px;
	}

	.cardDivider {
		height: 1px;
		background: rgba(31, 38, 53, 0.1);
		margin-left: 20px;
		margin-right: 20px;
	}

	.cardContent {
		padding-left: 35px;
		padding-right: 35px;
		margin-top: 15px;
		margin-bottom: 10px;
	}

	.thoughtBox {
		margin-top: 15px;
		background: rgba(94, 103, 121, 0.05);
		margin-left: 20px;
		margin-right: 20px;
		border-radius: 8px;
		margin-bottom: 0;
	}

	.thoughtHeader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 40px;
		cursor: pointer;
	}

	.thoughtHeaderLeft {
		display: flex;
		align-items: center;
	}

	.thoughtIcon {
		width: 16px;
		height: 16px;
		cursor: pointer;
		margin-left: 15px;
	}

	.thoughtTitle {
		margin-left: 4px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		font-size: 14px;
		color: rgba(94, 103, 121, 1);
		line-height: 20px;
	}

	.thoughtArrow {
		width: 24px;
		height: 24px;
		cursor: pointer;
		margin-right: 15px;
	}

	.toolContainer {
		display: flex;
		align-items: center;
	}

	.toolContainerNormal {
		padding: 0 20px 15px 20px;
	}

	.toolContainerBottom {
		padding: 0 20px 20px 20px;
	}

	.split {
		height: 1px;
		background: rgba(94, 103, 121, 0.1);
		margin-left: 20px;
		margin-right: 20px;
		margin-bottom: 16px;
	}

	.play_btn {
		display: flex;
		align-items: center;
		cursor: pointer;
		width: 30px;
		height: 30px;
		position: relative;
		overflow: hidden;
		border-radius: 8px;
		justify-content: center;
		align-items: center;

		&::after {
			content: '';
			position: absolute;
			inset: 0;
			background: rgba(74, 124, 232, 0.1);
			opacity: 0;
			pointer-events: none;
			transition: opacity 0.12s ease;
		}
	}

	.playIcon {
		width: 30px;
		height: 30px;
	}

	.playIconSmall {
		width: 15px;
		height: 15px;
	}

	.cardLoading {
		display: flex;
		height: 120px;
		background: #FFFFFF;
		box-shadow: 0 0 10px 0 #D9E7F1;
		border-radius: 2px 12px 12px 12px;
		margin-top: 15px;
		overflow: hidden;
	}
}

@media (hover: hover) and (pointer: fine) {
	.ai_share_card_1 .play_btn:hover::after {
		opacity: 1;
	}
}

@media (hover: none) and (pointer: coarse) {
	.ai_share_card_1 .play_btn:active::after {
		opacity: 1;
	}

	.ai_share_card_1 .play_btn.is-pressed::after {
		opacity: 1;
	}
}

</style>

<style lang="scss">
.ai_thought_content {
	margin-left: 35px;
	margin-right: 15px;
	margin-top: 12px;
	color: rgba(94, 103, 121, 0.5);
	font-size: 12px;
	line-height: 17px;
	li {
		margin-bottom: 6px;
	}
	h3 {
		font-size: 12px;
		line-height: 17px;
		color: rgba(94, 103, 121, 0.5);
		font-weight: 400;
	}
}
</style>